import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=5d0ccf72&scoped=true&"
import script from "./AccountEdit.vue?vue&type=script&lang=js&"
export * from "./AccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./AccountEdit.vue?vue&type=style&index=0&id=5d0ccf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ccf72",
  null
  
)

export default component.exports